/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CallNotification } from '../../models/call-notification';

export interface GetCallNotification$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
}

export function getCallNotification(http: HttpClient, rootUrl: string, params: GetCallNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<CallNotification>> {
  const rb = new RequestBuilder(rootUrl, getCallNotification.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CallNotification>;
    })
  );
}

getCallNotification.PATH = '/notification/call/{uid}';
